var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hit-html-html hit-table-responsive"},[_c('table',{staticClass:"hit-table hit-html-table",class:{
    'hit-table-striped': !_vm.settings || _vm.settings.striped !== false,
    'hit-table-bordered': !_vm.settings || _vm.settings.bordered !== false
  }},[_c('hit_thead',{attrs:{"titles":_vm.titles,"icons":_vm.icons}}),_c('hit_tbody',{attrs:{"titles":_vm.titles,"data":_vm.data,"actions":_vm.actions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }